import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {Router} from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const token = localStorage.getItem('token');
        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request)
          .do((ev: HttpEvent<any>) => {
            if (ev instanceof HttpResponse) {

              // For all invalid token responses redirect to login page
              //if (ev.body.api_status && ev.body.api_status == -1 ) {
                //this.router.navigateByUrl("/login");
              //}
            }
          });
    }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/services/jwt.interceptor.ts